/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：136
 */

module.exports = {
  oTButton: "style_oTButton__3Iy-r",
  collIconWrapper: "style_collIconWrapper__3sgII",
  collIcon: "style_collIcon__17BtD",
  activeCollIconWrapper: "style_activeCollIconWrapper__1vRac",
  content: "style_content__3VBNI",
  header: "style_header__35e2l",
  shareButton: "style_shareButton__3ZjBW",
  invitationIcon: "style_invitationIcon__2jbsV",
  list: "style_list__1fAXu",
  name: "style_name__dylvm",
  role: "style_role__3K1Uk",
  edit_role: "style_edit_role__2Y8FH",
  disabled: "style_disabled__18MWG",
  icon: "style_icon__1TIQs",
  active: "style_active__3x0oG",
  permissionDialog: "style_permissionDialog__1eSah",
  item: "style_item__1gLpV",
  selected: "style_selected__1nWl2",
  remove: "style_remove__1S4J7",
  shareOtDialog: "style_shareOtDialog__aY4aN",
  title: "style_title__3hfPu",
  dialogMain: "style_dialogMain__11r2T",
  description: "style_description__1FvWp",
  url: "style_url__vj4rf",
  loadingUrl: "style_loadingUrl__1hsjc",
  text: "style_text__3aFZs",
  tab: "style_tab__3qJ-0",
  copy: "style_copy__1mmjA",
  loadingBtn: "style_loadingBtn__37nla",
  spinner: "style_spinner__1EcrQ",
  headPhoto: "style_headPhoto__1AtXB",
  countPhoto: "style_countPhoto__3KdxQ",
  headerPhotoBorder: "style_headerPhotoBorder__157Dm",
  users: "style_users__1_LCz",
  user: "style_user__3AL2u",
  otherUsers: "style_otherUsers__2hxPx",
  card: "style_card__3S93p",
  cardContent: "style_cardContent__1XV6n",
  cardItem: "style_cardItem__191T_",
  loadingDialog: "style_loadingDialog__1z-ob",
  invalidUrlDialog: "style_invalidUrlDialog__EiVSq",
  userFocusCard: "style_userFocusCard__1fHLm",
  nickname: "style_nickname__2yhbA",
  avatarPopover: "style_avatarPopover__1hsf2",
  avatarContent: "style_avatarContent__2gjh9",
  avatarItem: "style_avatarItem__1t3I7",
  avatarImg: "style_avatarImg__3Geo7",
  itemName: "style_itemName__YxOUj"
}
